import React from 'react';
import styled from 'styled-components';

const DarkCircle = props => <Root {...props}>{props.text}</Root>;

export default DarkCircle;

const Root = styled.div`
  background-color: ${({ theme }) => theme.colorDarkBlue};
  width: 300px;
  height: 300px;
  border-radius: 50%;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2%;
  text-align: center;
  font-family: ${({ theme }) => theme.fontMain};
  font-size: 16px;
  line-height: 20px;
  span {
    color: ${({ theme }) => theme.colorPrimary};
  }
  p {
    max-width: 200px;
    margin-bottom: 10px;
  }
  h3 {
    max-width: 200px;
    font-family: ${({ theme }) => theme.fontHeader};
    font-size: 20px;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colorPrimary};
    margin-bottom: 10px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/DarkCircle.js